import { types } from '../actions/types';
import { formTemplates } from './formTemplates';

const DEFAULT_STATE = {
    formValues: null,
    formStructure: null,
    formType: 'default'
};

export default (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case types.CONFIRM_BOOKING_DATA_SUCCESS:
            return {
                ...state, formValues: action.payload
            }
        case types.CONFIRM_BOOKING_DATA_FAIL:
            return {
                ...state, formValues: null, error: 'Could not submit form. Form data was undefined.'
            }
        case types.RESET_BOOKING_DATA:
            return {
                ...state, formValues: null
            }
        case types.SET_FORM_TYPE: {
            return {
                ...state, formType: action.payload, formStructure: formTemplates[action.payload]
            }
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/form-reducer.js